export const layoutProps = {
  rows: ['1fr'],
  columns: ['1fr'],
  gap: '24px',
  alignItems: 'start',
  height: 'min-content',
  columnStart: 1,
  columnEnd: 12
}

export const columnData = {
  Email: { name: 'Email', widthCol: '40%' },
  FullName: { name: 'Nombre', widthCol: '40%' },
  DateCreated: { name: 'Fecha de creación', widthCol: '20%' },
  Status: { name: 'Estado', widthCol: '20%' }
}

export const options = [
  { id: 1, label: 'Filas por páginas: 15', value: 15 },
  { id: 2, label: 'Filas por páginas: 30', value: 30 },
  { id: 3, label: 'Filas por páginas: 45', value: 45 }
]
